import AntPopover from 'antd/lib/popover';

export const Popover = AntPopover;
